const initState = true;

const reducers = {
  false() {
    return false;
  },
  true() {
    return true;
  },
};

export const firstRender = {
  state: initState,
  reducers: reducers,
};
